export function getDiscoveryBaseUrl(): string {
  const baseUrl = process.env.NEXT_PUBLIC_DISCOVERY_APP_URL || '';
  return baseUrl.replace(/\/$/, '');
}

export function getDiscoveryAppUrlWithJwt(token: string): string {
  const baseUrl = getDiscoveryBaseUrl();
  const params = new URLSearchParams({ jwt: token });
  return `${baseUrl}?${params.toString()}`;
}

export function getDiscoveryProfileUrl(creatorId: string, token?: string): string {
  const baseUrl = getDiscoveryBaseUrl();
  const encodedCreatorId = encodeURIComponent(creatorId);
  const params = new URLSearchParams();

  if (token) {
    params.set('jwt', token);
  }

  const queryString = params.toString();
  return `${baseUrl}/creator/${encodedCreatorId}/public${queryString ? `?${queryString}` : ''}`;
}
